@let item = entry();
<div class="work-card padding-16">
  <div class="flex space-between vertical-center margin-bottom-8">
    <h3>{{ item.subject }}</h3>
    <div class="work-buttons">
      @if (canEdit()) {
        <work-ui-button (buttonClick)="editClick.emit(item)"
                        [iconOnly]="true"
                        size="small"
                        iconName="edit"
                        variant="secondary" />
      }
      @if (canDelete()) {
        <work-ui-button (actionConfirmResult)="deleteClick.emit(item)"
                        [iconOnly]="true"
                        size="small"
                        workUiShowConfirmActionModal
                        iconName="delete"
                        variant="secondary" />
      }
    </div>
  </div>
  <div class="flex flex-column gap-4">
    <p><strong>{{ 'PERSONALDOSSIER_KATEGORIE' | translate }}:</strong> {{ item.category?.name ?? '-' }}</p>
    <p><strong>{{ 'PERSONALDOSSIER_DATUM' | translate }}:</strong> {{ item.entryDate | formatDate: 'DD.MM.YYYY' }}</p>
    @if (item.notes) {
      <p>{{ item.notes }}</p>
    }
    @if (item.createdByUser) {
      <p class="work-text-color-secondary">
        {{ 'PERSONALDOSSIER_ERSTELLT_VON' | translate }}: {{ item.createdByUser.firstName }} {{ item.createdByUser.lastName }}
      </p>
    }
  </div>
</div>
